export default __webpack_public_path__ + "static/media/vip-logo-platinum-current.cc898588.webp";